import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * 這個 SPA session 內是否還有「上一頁」可以回。
 *
 * react-router v6 的 BrowserRouter 會在 history.state 裡維護 idx
 * （進站第一頁是 0，每 push 一次 +1）。idx > 0 代表使用者是從站內某一頁
 * 走過來的，navigate(-1) 會回到那一頁；idx 為 0 或不存在，代表這頁是重整、
 * 貼網址或從外部連結直接開的，此時 navigate(-1) 會把人踢出網站。
 */
export const canGoBack = () => (window.history.state?.idx ?? 0) > 0

/**
 * 返回鍵用的 hook：有站內歷史就回真正的上一頁，沒有才退回 fallback 路由。
 *
 * 寫死 navigate('/xxx') 的返回鍵會讓「從 A 進來卻被丟到 B」，
 * 例如從結帳頁點進服務詳情、按返回卻跳到服務列表。
 *
 * @param {string} fallback 沒有站內歷史時要去的路由
 * @returns {() => void} 可直接掛在 onClick 上
 */
const useGoBack = (fallback = '/') => {
  const navigate = useNavigate()

  return useCallback(() => {
    if (canGoBack()) {
      navigate(-1)
      return
    }
    navigate(fallback, { replace: true })
  }, [navigate, fallback])
}

export default useGoBack
